// packages/frontend/src/config/authConfig.ts

/**
 * Authentication configuration constants
 */
export const AUTH_CONFIG = {
  /**
   * Minutes before token expiration to show warning
   */
  TOKEN_EXPIRATION_WARNING_MINUTES: 5,

  /**
   * Interval in milliseconds to check token expiration
   */
  TOKEN_CHECK_INTERVAL_MS: 60000, // 1 minute

  /**
   * Default JWT token duration in hours
   * Can be overridden by backend API response
   */
  JWT_TOKEN_DURATION_HOURS: parseInt(
    import.meta.env.VITE_JWT_TOKEN_DURATION_HOURS || '24',
    10
  ),

  /**
   * Firebase token duration in hours (Firebase default, not configurable)
   */
  FIREBASE_TOKEN_DURATION_HOURS: 1,

  /**
   * Enable automatic logout when token expires
   */
  AUTO_LOGOUT_ON_EXPIRATION: true,

  /**
   * Services to monitor for token expiration
   */
  SERVICES_TO_MONITOR: ['cloudRun', 'cloudRunGenAI', 'firebaseFunctions'] as const,
} as const;

